import Link from 'next/link';
import React from 'react';
import { FaStar } from 'react-icons/fa';
import { TbShoppingCart } from 'react-icons/tb';
import { When } from 'react-if';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';

import AlternativeSuggestionProductModel from '@/models/alternative-suggestions-product.model';

type Props = {
  data: AlternativeSuggestionProductModel;
};

export default function SuggestedAlternativeProductCard({ data }: Props) {
  return (
    <Link href={`/web/${data.slug}`} prefetch={false}>
      <Container className='flex h-[96px] items-center justify-start gap-3 overflow-hidden pl-7 pr-3.5 md:h-[208px] md:flex-col  md:gap-0 md:px-0 md:text-center '>
        <XImage
          src={data.icon.publicLink}
          alt={data.icon.title}
          width={80}
          height={80}
          className='cover-fill mx-0 h-auto max-w-full rounded-[10px] md:mx-auto'
        />
        <Container>
          <Text className=' text-right text-xs font-extraBold leading-[22px] text-[#5B5C60] md:mb-7 md:mt-5 md:pl-4 md:pr-5 md:text-center md:text-sm'>
            {data.title}
          </Text>
          <Container center className='items-center justify-start gap-3 pt-1 md:hidden '>
            <When condition={!!data.rate}>
              <Container center className=' items-center gap-1'>
                <Container className='pb-1'>
                  <FaStar color='#FEA000' size={14} />
                </Container>
                <Text
                  type={TEXT_TYPE.SPAN}
                  className='productRate text-sm font-bold leading-[22px] text-[#878F9B] md:text-[28px]'
                >
                  {data.rate.rateAverage.toFixed(1)}
                </Text>
              </Container>
            </When>
            <Container center className='items-center gap-1 '>
              <Container className='pb-1'>
                <TbShoppingCart color='#878F9B' size={17} />
              </Container>
              <Text className='text-sm leading-[22px] text-[#878F9B]'>{data.saleAmount}</Text>
            </Container>
          </Container>
        </Container>
      </Container>
    </Link>
  );
}
